import React, { useState } from "react";
import Mascote from "./Mascote";
import { motion, AnimatePresence } from "framer-motion";

const falas = [
  "Oi! Eu sou o mascote da nana! 💖",
  "Estou com fome! 🍔",
  "Que carinho gostoso!",
  "Ai! Isso doeu! 😵",
  "Vamos brincar?",
  "Me dá comida, por favor!",
  "Estou com sono... 😴",
  "Adoro tomar banho! 🛁",
  "Estou tão feliz com vocês! 💕",
];

export default function MascotePage() {
  const [fala, setFala] = useState("");
  const [animando, setAnimando] = useState(false);
  const [fome, setFome] = useState(50);
  const [felicidade, setFelicidade] = useState(70);
  const [sono, setSono] = useState(40);
  const [limpeza, setLimpeza] = useState(80);

  // Falar
  const interagirMascote = () => {
    setFala(falas[Math.floor(Math.random() * falas.length)]);
    setAnimando(true);
    setTimeout(() => setFala(""), 3000);
    setTimeout(() => setAnimando(false), 800);
    setFelicidade((f) => Math.min(100, f + 5));
  };

  // Bater
  const baterMascote = () => {
    setFala("Ai! Não faz isso! 😢");
    setAnimando(true);
    setTimeout(() => setFala(""), 2000);
    setTimeout(() => setAnimando(false), 800);
    setFome((f) => Math.max(0, f - 10));
    setFelicidade((f) => Math.max(0, f - 20));
  };

  // Alimentar
  const alimentarMascote = () => {
    setFala("Humm, que delícia! 😋");
    setAnimando(true);
    setTimeout(() => setFala(""), 2000);
    setTimeout(() => setAnimando(false), 800);
    setFome((f) => Math.min(100, f + 30));
    setFelicidade((f) => Math.min(100, f + 10));
  };

  // Brincar
  const brincarMascote = () => {
    setFala("Adoro brincar! 🥳");
    setAnimando(true);
    setTimeout(() => setFala(""), 2000);
    setTimeout(() => setAnimando(false), 800);
    setFelicidade((f) => Math.min(100, f + 20));
    setSono((s) => Math.min(100, s + 10));
    setFome((f) => Math.max(0, f - 5));
  };

  // Dormir
  const dormirMascote = () => {
    setFala("Boa noite... 😴");
    setAnimando(true);
    setTimeout(() => setFala(""), 2500);
    setTimeout(() => setAnimando(false), 800);
    setSono(0);
    setFelicidade((f) => Math.min(100, f + 10));
  };

  // Banho
  const banhoMascote = () => {
    setFala("Agora estou limpinho! 🛁");
    setAnimando(true);
    setTimeout(() => setFala(""), 2000);
    setTimeout(() => setAnimando(false), 800);
    setLimpeza(100);
    setFelicidade((f) => Math.min(100, f + 5));
  };

  // Estados caem com o tempo
  React.useEffect(() => {
    const timer = setInterval(() => {
      setFome((f) => Math.max(0, f - 1));
      setFelicidade((f) => Math.max(0, f - 1));
      setSono((s) => Math.min(100, s + 1));
      setLimpeza((l) => Math.max(0, l - 1));
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  // Expressão do mascote (pode usar para trocar imagem ou animação)
  let status = "feliz";
  if (fome < 20) status = "fome";
  else if (felicidade < 20) status = "triste";
  else if (sono > 80) status = "sono";
  else if (limpeza < 20) status = "sujo";

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-pink-50">
      <h1 className="text-3xl font-bold text-pink-700 mb-6">Nosso sapinho</h1>
      <div className="relative flex flex-col items-center">
        <Mascote
          onClick={interagirMascote}
          onDoubleClick={baterMascote}
          size="grande"
          animando={animando}
          status={status}
        />
        <AnimatePresence>
          {fala && (
            <motion.div
              key="balao"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
              transition={{ duration: 0.4 }}
              className="absolute -top-20 -translate-x-1/2 bg-white border-2 border-pink-300 rounded-xl px-6 py-3 shadow-lg text-pink-700 font-semibold text-lg z-10"
              style={{ minWidth: 220 }}
            >
              <span>{fala}</span>
              <div className="absolute left-1/2 -bottom-4 -translate-x-1/2 w-0 h-0 border-x-8 border-x-transparent border-t-8 border-t-white border-b-0" />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      <div className="flex gap-3 mt-8 flex-wrap justify-center">
        <button
          onClick={alimentarMascote}
          className="px-4 py-2 bg-green-400 text-white rounded-xl shadow hover:bg-green-500 font-bold"
        >
          Alimentar 🍔
        </button>
        <button
          onClick={brincarMascote}
          className="px-4 py-2 bg-yellow-400 text-white rounded-xl shadow hover:bg-yellow-500 font-bold"
        >
          Brincar 🥎
        </button>
        <button
          onClick={banhoMascote}
          className="px-4 py-2 bg-blue-400 text-white rounded-xl shadow hover:bg-blue-500 font-bold"
        >
          Banho 🛁
        </button>
        <button
          onClick={dormirMascote}
          className="px-4 py-2 bg-purple-400 text-white rounded-xl shadow hover:bg-purple-500 font-bold"
        >
          Dormir 😴
        </button>
        <button
          onClick={baterMascote}
          className="px-4 py-2 bg-red-400 text-white rounded-xl shadow hover:bg-red-500 font-bold"
        >
          Bater 😢
        </button>
        <button
          onClick={interagirMascote}
          className="px-4 py-2 bg-pink-400 text-white rounded-xl shadow hover:bg-pink-500 font-bold"
        >
          Falar 💬
        </button>
      </div>
      <div className="mt-6 w-64 space-y-2">
        <StatusBar label="Fome" value={fome} color="bg-green-400" />
        <StatusBar label="Felicidade" value={felicidade} color="bg-yellow-400" />
        <StatusBar label="Sono" value={100 - sono} color="bg-purple-400" />
        <StatusBar label="Limpeza" value={limpeza} color="bg-blue-400" />
      </div>
    </div>
  );
}

// Componente para barra de status
function StatusBar({ label, value, color }) {
  return (
    <div>
      <div className="text-pink-700 font-semibold mb-1">{label}:</div>
      <div className="w-full h-4 bg-pink-200 rounded-full overflow-hidden">
        <div
          className={`h-4 ${color} transition-all`}
          style={{ width: `${value}%` }}
        />
      </div>
    </div>
  );
}